<template>
  <div class="personal-details">
    <div class="row" v-if="isActive || isFilled">
      <div class="col-xs-12 col-sm-12 col-md-12">
        <div class="row">
          <div class="col-xs-2 col-sm-2 col-md-1">
            <div
              class="number-circle lh35 cl-white brdr-circle align-center weight-700"
              :class="{ 'bg-cl-th-accent' : isActive, 'bg-cl-tertiary' : !isActive }"
            >
              2
            </div>
          </div>
          <div class="col-xs-8 col-sm-8 col-md-10" :class="{ 'cl-bg-tertiary' : !isActive }">
            <h3 class="m0">
              {{ $t('Personal Details') }}
            </h3>
          </div>
          <div class="col-xs-2 col-sm-2 col-md-1 end-xs">
            <i data-v-0c2f6ec6="" class="material-icons arrow-i"
               :class="{ 'active' : isActive }"
            >keyboard_arrow_right</i>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt15 " id="authentication" v-if="isActive && !currentUser">
      <div class="col-xs-6">
        <button-full
          class=" button-transp  center-xs middle-xs"
          :class="{'is-checked' : loginOption === 'no-login'}"
          data-testid="personalDetailsSubmit"
          @click.native="setLoginOption('no-login')"
        >
          <i data-v-0c2f6ec6="" class="material-icons">arrow_right_alt</i>
          {{ $t('Continue to personal data') }}
        </button-full>
      </div>
      <div class="col-xs-6" >
        <button-full
          @click.native="gotoAccount"
          class="button-transp center-xs middle-xs"
        >
          <i data-v-0c2f6ec6="" class="material-icons">exit_to_app</i>
          {{ $t('Login') }}
        </button-full>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-12">
            <div class="lh30 flex end-xs" v-if="!isActive && isFilled">
              <a href="#" class="cl-tertiary flex" @click.prevent="edit">
                <span class="pr5 h6">
                  {{ $t('Edit') }}
                </span>
                <i class="material-icons cl-tertiary">edit</i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="isActive">
      <div class="col-xs-12 pt20">
        <div class="row">
          <base-input
            class="col-xs-12 col-md-6 start-xs"
            type="text"
            :autofocus="true"
            name="first-name"
            :placeholder="$t('First name *')"
            v-model.trim="personalDetails.firstName"
            @blur="$v.personalDetails.firstName.$touch()"
            autocomplete="given-name"
            :validations="[
              {
                condition: $v.personalDetails.firstName.$error && !$v.personalDetails.firstName.required,
                text: $t('Field is required')
              },
              {
                condition: !$v.personalDetails.firstName.minLength,
                text: $t('Name must have at least 2 letters.')
              }
            ]"
          />

          <base-input
            class="col-xs-12 col-md-6 start-xs"
            type="text"
            name="last-name"
            :placeholder="$t('Last name *')"
            v-model.trim="personalDetails.lastName"
            @blur="$v.personalDetails.lastName.$touch()"
            autocomplete="family-name"
            :validations="[{
              condition: $v.personalDetails.lastName.$error && !$v.personalDetails.lastName.required,
              text: $t('Field is required')
            }]"
          />

          <base-telephone-input
            ref="telephone-input"
            class="col-xs-12 create-address shipping-address relative"
            :required="true"
            :validations="phoneValidations"
            :value="personalDetails.phone_number"
            @update="updatePhoneNumber"
            @input="$v.personalDetails.phone_number.$touch()"
          />

          <base-input
            class="col-xs-12 start-xs"
            type="email"
            name="email-address"
            :placeholder="$t('Email address *')"
            v-model="personalDetails.emailAddress"
            @blur="$v.personalDetails.emailAddress.$touch()"
            autocomplete="email"
            @keyup.enter="sendDataToCheckout"
            :validations="[
              {
                condition: $v.personalDetails.emailAddress.$error && !$v.personalDetails.emailAddress.required,
                text: $t('Field is required')
              },
              {
                condition: !$v.personalDetails.emailAddress.email && $v.personalDetails.emailAddress.$error,
                text: $t('Please provide valid e-mail address.')
              }
            ]"
          />
        </div>
      </div>
    </div>
    <div class="row" v-if="isActive">
      <div class="col-xs-12">
        <div class="row my15">
          <div class="col-xs-12 col-md-7 button-container" style="margin: auto">
            <button-full
              data-testid="personalDetailsSubmit"
              @click.native="sendDataToCheckout"
              :disabled="$v.personalDetails.$invalid"
            >
              {{ $t('Continue to courier pickup address') }}
            </button-full>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="!isActive && isFilled ">
      <div class="col-xs-12 brdr-bottom-1 brdr-cl-bg-secondary ">
        <div class="row fs16 mb15  bg-cl-secondary">
          <div class="col-xs-12 h4 pb15">
            <p>
              {{ personalDetails.firstName }} {{ personalDetails.lastName }}
            </p>
            <div>
              <span class="pr15">{{ personalDetails.phone_number }}</span>
              <tooltip>{{ $t('Phone number may be needed by carrier') }}</tooltip>
            </div>
            <div>
              <span class="pr15">{{ personalDetails.emailAddress }}</span>
              <tooltip>{{ $t('We will send you details regarding the order') }}</tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'
import { mapState, mapGetters } from 'vuex'

import BaseInput from 'theme/components/core/blocks/Form/BaseInput'
import ButtonFull from 'theme/components/theme/ButtonFull'
import Tooltip from 'theme/components/core/Tooltip'
const BaseTelephoneInput = () => import(/* webpackChunkName: "vsf-base-telephone-input" */ 'theme/components/core/blocks/Form/BaseTelephoneInput.vue');

export default {
  components: {
    ButtonFull,
    Tooltip,
    BaseInput,
    BaseTelephoneInput
  },
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    focusedField: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      isFilled: false,
      personalDetails: this.$store.state['pickup-checkout'].personalDetails,
      acceptConditions: false,
      isValidationError: false,
      loginOption: 'no-login',
      phoneMeta: {
        isValid: false
      },
      useAccountLogin: false
    }
  },
  watch: {
    isActive () {
      if (!this.personalDetails.emailAddress && this.currentUser) {
        let phoneNumber = this.currentUser.phone_number
        if (!phoneNumber) {
          phoneNumber = this.currentUser.telephone
        }
        if (!phoneNumber) {
          phoneNumber = this.currentUser.phoneNumber
        }
        this.personalDetails = {
          firstName: this.currentUser.firstname,
          lastName: this.currentUser.lastname,
          emailAddress: this.currentUser.email,
          phone_number: phoneNumber
        }
        this.sendDataToCheckout()
      }
    },
    currentUser () {
      if (!this.currentUser) return;

      let phoneNumber = this.currentUser.phone_number
      if (!phoneNumber) {
        phoneNumber = this.currentUser.telephone
      }
      if (!phoneNumber) {
        phoneNumber = this.currentUser.phoneNumber
      }
      this.personalDetails = {
        firstName: this.currentUser.firstname,
        lastName: this.currentUser.lastname,
        emailAddress: this.currentUser.email,
        phone_number: phoneNumber
      }
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.user.current
    }),
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn'
    }),
    phoneValidations () {
      let validation = this.$v.personalDetails.phone_number
      return [
        {
          condition: validation.$error && !validation.required,
          text: this.$t('Field is required')
        },
        {
          condition: validation.$error && validation.required && !validation.minLength,
          text: this.$t('Incorrect type of number')
        }
      ]
    }
  },
  methods: {
    updatePhoneNumber (value) {
      this.phoneMeta = value;

      if ('formattedNumber' in value) {
        this.personalDetails.phone_number = value.formattedNumber;
      }
    },
    checkValidation (valid) {
      this.isNotValidPhone = valid.$invalid
    },
    onLoggedIn (receivedData) {
      let phoneNumber = receivedData.phone_number
      if (!phoneNumber) {
        phoneNumber = receivedData.telephone
      }
      if (!phoneNumber) {
        phoneNumber = receivedData.phoneNumber
      }
      this.personalDetails = {
        firstName: receivedData.firstname,
        lastName: receivedData.lastname,
        emailAddress: receivedData.email,
        phone_number: phoneNumber
      }
      this.sendDataToCheckout()
    },
    setLoginOption (optionCode) {
      this.loginOption = optionCode
    },
    sendDataToCheckout () {
      if (this.$v.personalDetails.$invalid && !this.useAccountLogin && !!this.$refs['telephone-input']) {
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t('Personal details form is not valid!'),
          action1: { label: this.$t('OK') }
        })
        return
      }
      this.$bus.$emit('pickup-checkout-after-personalDetails', this.personalDetails, this.$v)
      this.isFilled = true
      this.isValidationError = false
    },
    edit () {
      if (this.isFilled) {
        this.$bus.$emit('pickup-checkout-before-edit', 'personalDetails')
      }
    },
    gotoAccount () {
      this.useAccountLogin = true
      this.$bus.$emit('modal-show', 'modal-signup')
    }
  },
  beforeMount () {
    this.$bus.$on('user-after-loggedin', this.onLoggedIn)
  },
  destroyed () {
    this.$bus.$off('user-after-loggedin', this.onLoggedIn)
  },
  validations () {
    return {
      personalDetails: {
        firstName: {
          required,
          minLength: minLength(2)
        },
        lastName: {
          required
        },
        emailAddress: {
          required,
          email
        },
        phone_number: {
          required: () => required && 'phoneNumber' in this.phoneMeta,
          isValid: () => this.phoneMeta.isValid
        }
      },
      password: {
        required
      },
      rPassword: {
        required,
        sameAsPassword: sameAs('password')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .link {
    text-decoration: underline;
  }

  .login-prompt {
    @media (min-width: 1200px) {
      margin-top: 30px;
    }
  }
  #authentication {
    .button-transp {
      color: #111111;
      background-color: transparent;
      font-size: 13px;
      border-radius: 0;
      min-width: 100px;
      display: flex;

      &.brdr-right {
        border-right: 1px solid #efeff4;
      }
    }
    i{
      margin-right: 5px;
    }
    .is-checked{
      border: 1px solid #11bb2e;
      border-radius: 3px!important;
      background-color: #f2f2f2!important;
    }
  }
</style>
